import { Link } from 'react-router-dom';

type Props = {
  eyebrow?: string;
  title: string;
  description?: string;
  align?: 'left' | 'center';
  linkTo?: string;
  linkLabel?: string;
};

export default function SectionHeading({
  eyebrow,
  title,
  description,
  align = 'left',
  linkTo,
  linkLabel,
}: Props) {
  const alignClass = align === 'center' ? 'items-center text-center' : 'items-start text-left';

  return (
    <div className={`flex flex-col ${alignClass} ${linkTo ? 'md:flex-row md:items-end md:justify-between md:text-left' : ''} gap-4 mb-8 md:mb-10`}>
      <div className={align === 'center' ? 'flex flex-col items-center' : ''}>
        {eyebrow && (
          <span className="inline-flex items-center gap-2 text-xs font-label tracking-widest uppercase text-accent-600 mb-3">
            <span className="w-6 h-px bg-accent-400"></span>
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">{title}</h2>
        {description && (
          <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed font-body max-w-2xl">{description}</p>
        )}
      </div>
      {linkTo && linkLabel && (
        <Link
          to={linkTo}
          className="inline-flex items-center gap-2 text-sm font-label text-primary-700 hover:text-primary-800 whitespace-nowrap shrink-0"
        >
          {linkLabel}
          <i className="ri-arrow-right-line"></i>
        </Link>
      )}
    </div>
  );
}